/// <amd-module name="Repos/PullRequest/Attachments/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\pr-attachments\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Attach a new file to a pull request.
     * 
     * @param content - Content to upload
     * @param fileName - The name of the file.
     * @param repositoryId - The repository ID of the pull request’s target branch.
     * @param pullRequestId - ID of the pull request.
     * @param project - Project ID or project name
     */
    createAttachment(content: any, fileName: string, repositoryId: string, pullRequestId: number, project?: string): Promise<Git.Attachment>;
    /**
     * Get a list of files attached to a given pull request.
     * 
     * @param repositoryId - The repository ID of the pull request’s target branch.
     * @param pullRequestId - ID of the pull request.
     * @param project - Project ID or project name
     */
    getAttachments(repositoryId: string, pullRequestId: number, project?: string): Promise<Git.Attachment[]>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Attach a new file to a pull request.
     * 
     * @param content - Content to upload
     * @param fileName - The name of the file.
     * @param repositoryId - The repository ID of the pull request’s target branch.
     * @param pullRequestId - ID of the pull request.
     * @param project - Project ID or project name
     */
    public async createAttachment(
        content: any,
        fileName: string,
        repositoryId: string,
        pullRequestId: number,
        project?: string
        ): Promise<Git.Attachment> {

        return this.beginRequest<Git.Attachment>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/pullRequests/{pullRequestId}/attachments/{fileName}",
            routeValues: {
                project: project,
                fileName: fileName,
                repositoryId: repositoryId,
                pullRequestId: pullRequestId
            },
            customHeaders: {
                "Content-Type": "application/octet-stream",
            },
            body: content,
            isRawData: true
        });
    }

    /**
     * Get a list of files attached to a given pull request.
     * 
     * @param repositoryId - The repository ID of the pull request’s target branch.
     * @param pullRequestId - ID of the pull request.
     * @param project - Project ID or project name
     */
    public async getAttachments(
        repositoryId: string,
        pullRequestId: number,
        project?: string
        ): Promise<Git.Attachment[]> {

        return this.beginRequest<Git.Attachment[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/pullRequests/{pullRequestId}/attachments/{fileName}",
            routeValues: {
                project: project,
                repositoryId: repositoryId,
                pullRequestId: pullRequestId
            }
        });
    }

}

export const GitClientName = "Repos.PullRequestAttachments.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
